var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",staticClass:"cube-form",class:_vm.formClass,attrs:{"action":_vm.action},on:{"submit":_vm.submitHandler,"reset":_vm.resetHandler}},[_vm._t("default",function(){return _vm._l((_vm.groups),function(group,index){return _c('cube-form-group',{key:group.key || index,attrs:{"fields":group.fields,"legend":group.legend}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }